const SWIPER_TOP_SP = document.querySelector(".custom-top-kv-sp");
const SWIPER_TOP_SP_SLIDE_SPEED = SWIPER_TOP_SP.dataset.slideSpeed;

new Swiper(SWIPER_TOP_SP, {
  loop: true, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1.5, // 一度に表示する枚数
  centeredSlides: true, // アクティブなスライドを中央にする
  autoplay: {
    // 自動再生
    delay: SWIPER_TOP_SP_SLIDE_SPEED * 1000, // 1秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
